type TagProps = {
  bgColor: string
  textColor: string
  label: string
}

export const Tag = ({ bgColor, label, textColor }: TagProps) => {
  return (
    <div
      className={`align-center flex max-h-12 cursor-pointer justify-center rounded-full p-2 text-center text-xs font-semibold hover:bg-blue-600 hover:text-white dark:hover:bg-blue-600 ${bgColor} ${textColor}`}
    >
      <span className="flex justify-center self-center">{label}</span>
    </div>
  )
}
